export default "__VITE_ASSET__WimvGUe4__"